import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileStack } from 'lucide-react';
import CpaPacketDialog from './CpaPacketDialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/cpa-packet`;

export const usePacketSummary = () => {
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    axios.get(`${API}/summary`, { withCredentials: true }).then(r => setSummary(r.data)).catch(() => {});
  }, []);
  return summary;
};

export const PacketActions = ({ summary, testPrefix = 'cpa-packet', onSent }) => (
  <div className="flex flex-wrap gap-2">
    <CpaPacketDialog mode="download" summary={summary} testPrefix={testPrefix} />
    <CpaPacketDialog mode="email" summary={summary} testPrefix={testPrefix} onSent={onSent} />
  </div>
);

export const CpaPacketCard = () => {
  const summary = usePacketSummary();
  if (!summary) return null;
  const parts = [
    'Summary & savings tracker',
    summary.has_report ? 'Strategy report' : null,
    summary.advisor_count ? `${summary.advisor_count} advisor chat${summary.advisor_count === 1 ? '' : 's'}` : null,
  ].filter(Boolean);
  return (
    <section className="flex flex-wrap items-center gap-5 rounded-2xl border border-stone-200 bg-white p-5 shadow-sm" data-testid="cpa-packet-card">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700"><FileStack className="h-5 w-5" /></span>
      <div className="min-w-0 flex-1">
        <h2 className="text-base font-semibold text-stone-900">Year-End CPA Packet · {summary.year} tax year</h2>
        <p className="mt-0.5 text-sm text-stone-500" data-testid="cpa-packet-contents">{parts.join(' · ')}. Pick sections, then download or share a secure link.</p>
      </div>
      <PacketActions summary={summary} />
    </section>
  );
};

export default CpaPacketCard;
